import { useCallback, useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const useAsyncStorage = (key: string): AsyncStorageHook => {
  const [value, update] = useState<string | null>(null);

  // ─── Reads Value from Local Storage ─────────────────────────────
  useEffect(() => {
    void AsyncStorage.getItem(key).then((persisted) => {
      if (persisted) update(persisted);
    });
  }, [key]);

  // ─── Writes Value to Local Storage ──────────────────────────────
  const handleStorageUpdate = useCallback(
    (payload: string) => {
      update(payload);
      void AsyncStorage.setItem(key, payload);
    },
    [key],
  );

  return [value, handleStorageUpdate];
};

type AsyncStorageHook = readonly [string | null, (value: string) => void];
